import DentistSideMenu from './DentistSideMenu';
export default DentistSideMenu;
export type { DentistSideMenuProps } from './DentistSideMenu';
